import React from 'react';
import classnames from 'classnames'
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import { hasPermission } from '../../../store/apiWrapper'
import { connect } from 'react-redux';
import BbRadioWrapper from '../../styling/BbRadioWrapper';
import { isNull } from 'lodash';
import { validateInput } from '../../../store/storeFunctions';
class EgSettings extends React.Component {
    state = {
        initialized: false,
        filter: '',
        share: 0, 
        entityID: null
    }

    componentDidMount() {
        this.setupInitialData();
    }

    componentDidUpdate() {
        const egData = this.props.economicGroupSettings;
        
        if (egData.reload) {
            this.setupInitialData();
            this.props.egDataReloaded();
        }
    }

    setupInitialData = () => {
        const egData = this.props.economicGroupSettings;
        this.setState({ initialized: true, filter: egData.filter || "EG", share: egData.share || 0, entityID: egData.entityID });
    }

    render() {
        return (
            <>
                <BbRadioWrapper id="radio-EG" name="filter" value="EG"
                    checked={this.state.filter === 'EG'} callback={(e) => this.onFilterChange(e, false)}
                    label={hasPermission(null, 'EconomicGroupSberbankMethodology') ? this.props.translate('Report.Ess.SberbankMethodology') : this.props.translate('Report.EconomicGroup.Settings.EconomicGroup')}
                />
                <BbRadioWrapper id="radio-FO" name="filter" value="FO"
                    checked={this.state.filter === 'FO'} callback={(e) => this.onFilterChange(e, false)}
                    label={this.props.translate('Report.EconomicGroup.Settings.FinalOwners')}
                />
                
                {!hasPermission(null, 'EconomicGroupSberbankMethodology') &&
                <div style={{ lineHeight: '2.5em' }}>
                    <Translate id='Report.EconomicGroup.Settings.MinimalShare' />
                    {<input type='text' id='minimalShareInput'  
                    disabled = {hasPermission(null, "EconomicGroupEdit") ? "" : "disabled"} 
                    name='share' className='input' max={100} min={0} value={this.state.share} onChange={(e) => this.onFilterChange(e, false)} style={{ maxWidth: '4.5em', margin: '0 .5em', height: '2em' }} onInput={(e) => validateInput(e)}></input>}
                    %
                </div>
                }
                
                <div className={`buttons`} style={{ paddingBottom: '.5em', justifyContent: 'center', paddingTop: "1.5em" }}>
                    <button className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square'})} onClick={() => this.onFilterChange(undefined, true)} ><Translate id='Report.EconomicGroup.Settings.SetBtn' /></button>
                </div>
            </>
        );
    }

    onFilterChange = (e, submit) => {
        if (e !== undefined) {
            let copiedState = Object.assign({}, this.state);
            let input = null;

            if (!hasPermission(null, 'EconomicGroupSberbankMethodology')) {
                input = document.getElementById('minimalShareInput').value;
            } 
            
            if (e.target.name === "share"){
                if (!isNull(input)) { 
                    if ((/^(?!0\d)(100(\.0{1,2})?|(\d{1,2}([.,]\d{1,2})?))([,.]?)$/).test(input)) {
                        copiedState[e.target.name] = input.toString().replace(',','.');
                    }

                    if ( (/^(?!0\d)(100(\,0{1,2})?|(\d{1,2}(\,\d{1,2})?)),$|^$/).test(input)) {
                        copiedState[e.target.name] = input.toString().replace(',','.');
                    }
                } else
                    copiedState[e.target.name] = '0';
            } else 
                copiedState[e.target.name] = e.target.value;
            this.setState(copiedState);
        }
        if (submit === true) {
            this.props.getEgReportSettings(this.state.share, this.state.filter, this.state.entityID);
        }
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(EgSettings));